import React from 'react';
import { Loading as TLoading } from '@oscar/theme';
import './style.scss';

const Loading: React.FC = () => {
  return (
    <div className="full-loading" style={{ height: window.innerHeight }}>
      <TLoading size={36} color="#009089" />
    </div>
  );
};

export default Loading;
